import { nanoid } from "nanoid";
import { defineStore } from "pinia";
import { ofetch } from "ofetch";

export const useSettingsStore = defineStore("settings", () => {
  const sid = ref(nanoid(8));
  const settings = ref(null);

  async function loadSettings() {
    try {
      const response = await ofetch("/n/api/backoffice/public/settings", {
        retryDelay: 600,
        retry: 5,
        headers: { Sid: sid.value },
        responseType: "json",
      });
      settings.value = response;
      return response;
    } catch (err) {
      console.error("Failed to load settings:", err);
      throw err;
    }
  }

  function setSettings(settingsData) {
    settings.value = settingsData;
  }

  return {
    settings,
    loadSettings,
    setSettings,
  };
});
